import { render } from "./RequestItem.vue?vue&type=template&id=60554d41&scoped=true"
import script from "./RequestItem.vue?vue&type=script&lang=js"
export * from "./RequestItem.vue?vue&type=script&lang=js"

import "./RequestItem.vue?vue&type=style&index=0&id=60554d41&scoped=true&lang=css"

import exportComponent from "/Users/michaelp/Library/CloudStorage/OneDrive-個人/Visual Studio/Vue Complete/auth-09-adding-auto-login/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60554d41"]])

export default __exports__